import apiClient from './apiClient';

export const notificationsApi = {
	// Register device token
	registerDevice: async (token) => {
		try {
			const response = await apiClient.post(
				`/api/notifications/register-device`,
				{ token }
			);
			return response.data;
		} catch (error) {
			console.error('Register device error:', error);
			throw error.response?.data || error;
		}
	},

	// Get all notifications
	getAll: async (organizationId) => {
		try {
			const response = await apiClient.get(`/api/notifications`, {
				params: {
					organizationId,
				},
			});

			return Array.isArray(response.data) ? response.data : [];
		} catch (error) {
			console.error('Notifications API Error:', {
				status: error.response?.status,
				data: error.response?.data,
				message: error.message,
				details: error.response?.data?.errors,
			});
			return [];
		}
	},

	// Create notification
	create: async (notificationData) => {
		try {
			const response = await apiClient.post(
				`/api/notifications`,
				notificationData
			);
			return response.data;
		} catch (error) {
			throw error.response?.data || error;
		}
	},

	// Send notification immediately
	send: async (notificationId) => {
		try {
			const response = await apiClient.post(
				`/api/notifications/${notificationId}/send-now`,
				{}
			);
			return response.data;
		} catch (error) {
			throw error.response?.data || error;
		}
	},

	// Delete notification
	delete: async (notificationId) => {
		try {
			const response = await apiClient.delete(
				`/api/notifications/${notificationId}`
			);
			return response.data;
		} catch (error) {
			console.error('Delete API error:', {
				status: error.response?.status,
				data: error.response?.data,
				message: error.message,
				url: `/api/notifications/${notificationId}`,
			});
			throw error.response?.data || error;
		}
	},

	// Update notification
	update: async (notificationId, data) => {
		try {
			const response = await apiClient.patch(
				`/api/notifications/${notificationId}`,
				data
			);
			return response.data;
		} catch (error) {
			throw error.response?.data || error;
		}
	},
};
